export default {
  "fr": {
    "company": {
      "actions": {
        "changeCompany": "Changer entreprise",
        "searchCompany": "Rechercher entreprise"
      },
      "attributes": {
        "address": "Adresse",
        "email_address": "Email",
        "iban": "IBAN",
        "language": "Langue",
        "name": "Nom d'entreprise",
        "phone": "Téléphone",
        "subdomain": "Subdomain",
        "vat": "TVA"
      },
      "labels": {
        "company": "Entreprise",
        "contact": "Contact",
        "contacts": "Contacts",
        "language": "C'est la langue par défaut de la société pour votre page de connexion, vos clients et les membres de votre équipe.",
        "or": "OU"
      },
      "validation": {
        "contactAlreadyExist": "Le contact existe déjà. Veuillez sélectionner dans le menu déroulant.",
        "mustBeEmailAddress": "Adresse e-mail valide requise",
        "needName": "Le nom est requis"
      }
    }
  }
}